module.exports = __webpack_public_path__ + "static/img/empty.f807123b.png";